import { InjectionToken } from '@angular/core';

import { GtagConfig } from './gtag-config.interface';

export const GTAG_CONFIG = new InjectionToken<GtagConfig>('gtag-config');
